import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ProjectsService } from '@cosmos/angular/api';
import { ErrorService } from '@cosmos/angular/utils';
import { Project } from '@cosmos/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'cosmos-project-monitoring-settings',
    imports: [TranslatePipe, ReactiveFormsModule, CheckboxModule, ButtonModule],
    templateUrl: 'project-monitoring-settings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectMonitoringSettingsComponent implements OnInit {

    @Input()
    project: Project = null;

    @Output()
    updatedProject = new EventEmitter<Project>();

    monitoringConfig;

    constructor(
        private projectsService: ProjectsService,
        private formBuilder: FormBuilder,
        private errorService: ErrorService,
    ) { }

    ngOnInit() {
        this.monitoringConfig = this.formBuilder.group({
            defaultMeasurementStarted: [this.project.config?.monitoringConfig?.defaultMeasurementStarted ?? true],
        });
    }

    save() {
        const { defaultMeasurementStarted } = this.monitoringConfig.value;

        this.projectsService.updateMonitoringConfig(this.project._id, { defaultMeasurementStarted }).subscribe(
            this.errorService.handleMutation({
                successMessageKey: 'projects.monitoringConfig.messages.updateSuccess',
                onSuccess: () => this.updatedProject.emit({
                    ...this.project,
                    config: {
                        ...this.project.config,
                        monitoringConfig: { ...this.project.config?.monitoringConfig, defaultMeasurementStarted },
                    },
                }),
            }),
        );
    }
}
